/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { custom } from '@gh/core-data';
import { Locale } from '@gh/core-mls';

export const LocaleMapper = custom({
  serialize: (locale: Locale) => {
    return locale.toStandardString();
  },
  deserialize: (json) => {
    return Locale.createFromStandard(json);
  },
});
